const UNUSUAL_REDIRECT_LOCAL_STORAGE_KEY = 'redirect_uri';

const ALLOWED_REDIRECTS = ['/integration/embedded-container', '/subscription-management'];

const C_LEVEL_REPORT = '/overview';

export { ALLOWED_REDIRECTS, C_LEVEL_REPORT, UNUSUAL_REDIRECT_LOCAL_STORAGE_KEY };
